import React, { useEffect, useState, useRef } from "react";
import { bool, shape, string } from "prop-types";
import { connect, useDispatch } from "react-redux";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";

import { validatePhone } from "util/form";

import * as i18nUtils from "util/i18n";
import { goBack, push } from "connected-react-router";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { selectors as modalselectors, actions as modalActions } from "reducers/modal";
import { selectors as alertselectors, actions as alertActions } from "reducers/alert";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import { selectors as loginSelectors } from "reducers/login";
import PhoneInput from "pages/_components/fields/PhoneInput";
import { REGION_REST_OF_LATAM, REGION_ARG } from "constants.js";
import * as configUtils from "util/config";
import CustomText from "pages/_components/CustomText/CustomText";
import Container from "pages/_components/Container";
import Image from "pages/_components/Image";
import { Col } from "react-bootstrap";
import GridTable from "pages/_components/GridTable/GridTable";
import { usePhoneAreaCodesArg } from "../../../hooks/usePhoneAreaCodesArg";
import Stepper from "../_components/Stepper";
import ErrorPopup from "../_components/ErrorPopup";
import InfoModal from "../_components/InfoModal";

const FORM_ID = "onboarding.step.verifySMS";

const StepSms = ({
    isMobile,
    displayModal,
    displayAlert,
    activeRegion,
    verifyCode,
    exchangeToken,
    onboardingWithEnrolledUser,
}) => {
    const dispatch = useDispatch();

    const [mobilePhone, setMobilePhone] = useState("");
    const [country, setCountry] = useState(REGION_ARG);
    const [validateError, setvalidateError] = useState(false);
    const error = "";
    const [isValidating, setIsValidating] = useState(false);
    const [resendAvailable, setResendAvailable] = useState(true);
    const { argAreaCodes } = usePhoneAreaCodesArg();

    const TIME_TO_SEND_OTHER_CODE = configUtils.get("validation_code.retry.duration", 3) * 60000;

    const timerRef = useRef(null);

    const [pageId, setPageId] = useState("StepSms");

    useEffect(() => {
        if (onboardingWithEnrolledUser) {
            setPageId("StepSmsEnrolledUser");
        }
    }, [onboardingWithEnrolledUser]);

    useEffect(() => {
        if (activeRegion && activeRegion !== REGION_REST_OF_LATAM) {
            // setCountry(activeRegion.toLowerCase());
            setCountry(REGION_ARG);
        }
    }, [dispatch]);

    useEffect(() => {
        if (isValidating && verifyCode?.data && verifyCode?.status !== "OK" && verifyCode?.status !== "") {
            setIsValidating(false);
            // setError(verifyCode?.data.message);
            // dispatch(alertActions.alertShow());
            setvalidateError(true);
        } else if (isValidating && verifyCode?.status === "OK") {
            setIsValidating(false);
            if (verifyCode?.type === "send") {
                dispatch(modalActions.modalShow());
            } else if (verifyCode?.type === "receive") {
                dispatch(modalActions.modalClose());
                dispatch(push("/onboarding/stepSmsSuccess"));
            }
        }
    }, [isValidating, verifyCode]);

    const getSubtitle = () => {
        const params = { 1: mobilePhone };
        return i18nUtils.get("onboarding.step.verifySMS.modal.subtitle", null, params);
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const sendCode = (mobilePhoneToSend, shouldDisableBtn) => {
        setIsValidating(true);
        dispatch(onboardingActions.verifyCodeSend("sms", "", mobilePhoneToSend || mobilePhone));
        if (shouldDisableBtn) {
            setResendAvailable(false);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                setResendAvailable(true);
            }, TIME_TO_SEND_OTHER_CODE);
        }
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: true,
        initialValues: {
            mobilePhone: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                mobilePhone: validatePhone(argAreaCodes),
            }),

        onSubmit: (data) => {
            const { countryCode, areaCode, value } = data.mobilePhone;
            const phone = `+${countryCode}${areaCode}${value}`;
            setMobilePhone(phone);
            sendCode(phone, false);
            dispatch(onboardingActions.setMobileNumber(data.mobilePhone));
        },
    };

    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            code: "",
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
        },
        validationSchema: () =>
            Yup.object()
                .shape({
                    // code: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "*")),
                    code: Yup.string(),
                    code1: Yup.string(),
                    code2: Yup.string(),
                    code3: Yup.string(),
                    code4: Yup.string(),
                    code5: Yup.string(),
                })
                .test("errors", " ", (values) => {
                    const { code, code1, code2, code3, code4, code5 } = values;
                    if (!code || !code1 || !code2 || !code3 || !code4 || !code5) {
                        return false;
                    }
                    return true;
                }),
        onSubmit: (event, data) => {
            const { code, code1, code2, code3, code4, code5 } = data;
            const codeSend = `${code}${code1}${code2}${code3}${code4}${code5}`;
            setIsValidating(true);
            dispatch(onboardingActions.verifyCodeReceive(codeSend, "sms", "", mobilePhone, exchangeToken));
        },
    };

    const handleStopTimer = (e) => {
        // chequea que el click no sea desde el input o que no sea desde los botones
        if (e.target.localName !== "input" && e.target.parentElement.id === "") {
            clearTimeout(timerRef.current);
            dispatch(modalActions.modalClose());
        }
    };
    const validateForm = (val) => {
        if (val.split("").filter((x) => x === "9").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "8").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "7").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "6").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "5").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "4").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "3").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "2").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "1").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "0").length > 6) {
            return false;
        }
        return true;
    };
    const handleSendCode = (e) => {
        sendCode(mobilePhone, true);
        e.stopPropagation();
    };

    const handleOnSubmit = (formikPropsParam, event, data) => {
        event.stopPropagation();
        formikPropsParam.onSubmit(event, data);
    };
    const onFocus = (id, value) => {
        if (value === "") {
            return;
        }
        if (document.getElementById(id)) {
            document.getElementById(id).focus();
        }
    };

    const onFocusDown = (id, code, idLast, setFieldValue, value) => {
        if (code === "Backspace" && value === "") {
            if (document.getElementById(id)) {
                document.getElementById(id).focus();
            }
            if (idLast) {
                setFieldValue(idLast, "");
            }
        }
    };

    const createValidateEmailBodyModal = () => (
        <div>
            <Formik {...formikValidateProps}>
                {(allFormik) => (
                    <Form noValidate>
                        <GridTable className="token-code-fields">
                            <GridTable.Container>
                                <GridTable.Data>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code"
                                        id="code"
                                        hideLabel
                                        onKeyUp={(e) => {
                                            onFocus("code1", e.target.value);
                                        }}
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code1"
                                        id="code1"
                                        onKeyUp={(e) => {
                                            onFocus("code2", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code", e.code || e.key, null, null, allFormik.values.code1);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code3", e.target.value);
                                        }}
                                        name="code2"
                                        id="code2"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code1", e.code || e.key, null, null, allFormik.values.code2);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code4", e.target.value);
                                        }}
                                        name="code3"
                                        id="code3"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code2", e.code || e.key, null, null, allFormik.values.code3);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code4"
                                        id="code4"
                                        onKeyUp={(e) => {
                                            onFocus("code5", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code3", e.code || e.key, null, null, allFormik.values.code4);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code5"
                                        id="code5"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown(
                                                "code4",
                                                e.code || e.key,
                                                "code5",
                                                allFormik.setFieldValue,
                                                allFormik.values.code5,
                                            );
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                        {Object.keys(allFormik.errors).length > 0 && (
                            <div className="error">{allFormik.errors[Object.keys(allFormik.errors)[0]]}</div>
                        )}

                        <Button
                            bsStyle="link"
                            // label="onboarding.step.verifyEmail.modal.resendcode.action"
                            defaultLabelText="No me llegó el SMS"
                            loading={false}
                            onClick={handleSendCode}
                            disabled={!resendAvailable}
                            id="save-mobilePhone-button"
                        />

                        <Button
                            bsStyle="primary"
                            label="onboarding.step.verifySMS.modal.button.validate"
                            loading={false}
                            onClick={(ev) => handleOnSubmit(formikValidateProps, ev, allFormik.values)}
                            block
                            disabled={
                                !(
                                    allFormik.isValid &&
                                    allFormik.dirty &&
                                    allFormik.values.code?.length === 1 &&
                                    allFormik.values.code1?.length === 1 &&
                                    allFormik.values.code2?.length === 1 &&
                                    allFormik.values.code3?.length === 1 &&
                                    allFormik.values.code4?.length === 1 &&
                                    allFormik.values.code5?.length === 1
                                )
                            }
                            id="submit-button"
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );

    const onhandleClickAlert = () => {
        dispatch(alertActions.alertClose());
    };

    const createAlertBodyModal = () => <ErrorPopup error={error} handleClick={onhandleClickAlert} />;
    if (validateError) {
        return (
            <>
                {isMobile && (
                    <ResponsiveHeader
                        ticket
                        id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onClickBack={isMobile && onHeaderBack}
                    />
                )}
                <MainContainer>
                    {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <Head
                                    title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                                    onBack={isMobile && onHeaderBack}
                                />
                            </Col>
                        </Container>
                    )}

                    <div>
                        <Col xs={12} md={8} mdOffset={2}>
                            <h1 className="text-center">
                                <CustomText
                                    text={i18nUtils.get("onboarding.sms.errorSms", "No pudimos validar tu SMS")}
                                />
                            </h1>
                        </Col>
                        <div className="illustration text-center">
                            <Image src="figma/illustrations/onboarding14.svg" className="svg-image logo" />
                        </div>
                        {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                        <br />
                        <Col xs={12} md={8} mdOffset={2} className="box box-border-soft" style={{ padding: "20px" }}>
                            <CustomText
                                text={i18nUtils.get(
                                    "onboarding.sms.errorSms.description",
                                    "Se produjo un error al validar el SMS. Por favor, intente nuevamente.",
                                )}
                            />
                        </Col>

                        <Button
                            className="mt-8"
                            bsStyle="primary"
                            label="global.accept"
                            loading={false}
                            onClick={() => {
                                setvalidateError(false);
                                dispatch(modalActions.modalClose());
                                // dispatch(push("/onboarding/StepCUIT"))
                            }}
                        />
                    </div>
                </MainContainer>
            </>
        );
    }
    return (
        <>
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                {!isMobile && (
                    <Head
                        title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onBack={isMobile && onHeaderBack}
                    />
                )}
                <Stepper isMobile={isMobile} page={pageId} />

                {displayModal && (
                    <InfoModal
                        noAcceptButton
                        noCancelButton
                        bodyInfoText="texto"
                        modalSubtitle={getSubtitle()}
                        useScroll
                        body={createValidateEmailBodyModal}
                        onClick={handleStopTimer}
                    />
                )}
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <CustomText text={i18nUtils.get("", "Validá tu celular")} />
                </h1>
                <CustomText
                    text={i18nUtils.get(
                        "onboarding.sms.setCode.subtitle",
                        "Ingresá un número personal al que puedas acceder.",
                    )}
                />
                <Formik {...formikProps}>
                    {(allFormik) => (
                        <Form className="above-the-fold" noValidate>
                            <Field
                                component={PhoneInput}
                                idForm={FORM_ID}
                                name="mobilePhone"
                                country={country}
                                mobilePhone="54"
                                enableSearch={false}
                                preferredCountries={["ar"]}
                                hintLabel={i18nUtils.get(
                                    "onboarding.sms.phoneText",
                                    "Incluí tu código de área y luego tu número de celular, sin guiones ni espacios.",
                                )}
                                onlyCountries={configUtils.get("onboarding.step.sms.countries").split("|")}
                                // disableDropdown
                            />
                            <div className="form-actions">
                                <Button
                                    bsStyle="primary"
                                    label="global.continue"
                                    type="submit"
                                    block
                                    disabled={
                                        !(
                                            allFormik.isValid &&
                                            allFormik.dirty &&
                                            !!allFormik.values.mobilePhone?.value &&
                                            // (
                                            //     allFormik.values.mobilePhone?.countryCode +
                                            //     allFormik.values.mobilePhone?.areaCode +
                                            //     allFormik.values.mobilePhone?.value
                                            // ).length >= 10 &&
                                            validateForm(allFormik.values.mobilePhone?.value)
                                        )
                                    }
                                    loading={!!isValidating}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
            {displayAlert && (
                <InfoModal noAcceptButton noCancelButton bodyInfoText="texto" useScroll body={createAlertBodyModal} />
            )}
        </>
    );
};

StepSms.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
    activeRegion: string.isRequired,
    exchangeToken: string.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
    displayModal: bool,
    displayAlert: bool,
    verifyCode: shape({}),
};

StepSms.defaultProps = {
    displayModal: false,
    displayAlert: false,
    verifyCode: {},
};

const mapStateToProps = (state) => ({
    displayModal: modalselectors.getDisplayModal(state),
    activeRegion: loginSelectors.getRegion(state),
    verifyCode: onboardingSelectors.getVerifyCode(state),
    displayAlert: alertselectors.getDisplayAlert(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepSms);
